/* src/app/home-new/home-new.component.scss */
::-webkit-scrollbar {
  width: 3px;
}
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px #ffffff;
  border-radius: 10px;
}
::-webkit-scrollbar-thumb {
  background: var(--ion-color-primary);
  border-radius: 10px;
}
::-webkit-scrollbar-thumb:hover {
  background: #b7b7b7;
}
ion-content::part(scroll) {
  overflow: hidden;
}
main {
  height: 100%;
}
.settings {
  max-width: 27rem;
  min-width: 412px;
  height: 100%;
  width: 24%;
  position: absolute;
  background: #f6f6f6;
  z-index: 2;
}
.settings.collapsed {
  transform: translateX(-100%);
}
.mainContent {
  margin-left: 412px;
  position: relative;
  overflow-y: auto;
}
.mainContent.collapsed {
  margin-left: 0;
}
.mainContent .mainContent_container {
  padding: 10px 50px;
  overflow: auto;
}
.mainContent .mainContent_title h1 {
  font-weight: 700;
  font-size: 48px;
}
.mainContent .mainContent_title img {
  width: 45px;
  height: 45px;
}
.mainContent .mainContent_subtitle {
  font-weight: 400;
  font-size: 22px;
  text-align: center;
  margin: 0 100px 40px 100px;
}
.mainContent .slider {
  margin-top: 30px;
}
.summary {
  height: 100%;
  position: relative;
  background: #f6f6f6;
  padding: 25px 20px;
  overflow: hidden;
}
@media (max-width: 1600px) {
  .mainContent .mainContent_container {
    padding: 0px 10px;
  }
  .mainContent .mainContent_title h1 {
    font-size: 40px;
  }
  .mainContent .mainContent_title img {
    width: 40px;
    height: 40px;
  }
  .mainContent .mainContent_subtitle {
    font-weight: 400;
    font-size: 18px;
    text-align: center;
    margin: 0 50px 40px 50px;
  }
}
#fileDropRef {
  opacity: 0;
  width: 0;
  cursor: pointer;
}
#mobile-spacer {
  background: black;
  height: 70px;
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 99;
}
app-mobile-home-folders {
  z-index: 9999;
  height: 100%;
  width: 100%;
}
ion-fab {
  position: fixed;
  right: 27px;
  bottom: 320px;
  width: 60px;
  height: 60px;
}
ion-fab ion-fab-button::part(native) {
  width: 60px;
  height: 60px;
}
@media (max-width: 1300px) {
  .mainContent .mainContent_container {
    padding: 10px;
  }
  .mainContent .mainContent_title h1 {
    font-size: 30px;
  }
}
@media (max-width: 1165px) {
  .plane-logo {
    display: none;
  }
}
@media (max-width: 1104px) {
  .mainContent_title {
    padding: 0 30px;
  }
  .mainContent_title h1 {
    text-align: center;
  }
  .mainContent_subtitle {
    margin-bottom: 0 !important;
  }
  .settings {
    max-width: 100%;
    width: 100%;
    z-index: 9999;
  }
}
@media (max-width: 450px) {
  .mainContent_title h1 {
    font-size: 22px !important;
  }
  .mainContent_subtitle {
    font-size: 14px !important;
  }
}
@media (max-width: 413px) {
  .settings {
    min-width: unset !important;
  }
}
/*# sourceMappingURL=home-new.component-7BURJ2CG.css.map */
